import {PIXI} from '@colonist/pixi'
import {UIGameBeginnerHintIndicatorView} from './UIGameBeginnerHintIndicatorView'
import {UIGameManager} from '../UIGameManager'
import {UIGameBeginnerHintInformationView} from './UIGameBeginnerHintInformationView'
import {TranslationObject} from '@colonist/i18n'
import {bringToFront} from '../../ui_utils/PixiUtils'

/**
 * @deprecated use activateBeginnerHint from gameStore instead
 */
export class UIGameBeginnerHintView {
    private readonly hintIndicator: UIGameBeginnerHintIndicatorView
    private readonly hintInformation: UIGameBeginnerHintInformationView

    constructor(uiGameManager: UIGameManager, viewToPlaceAbove: PIXI.Container, descriptionText: TranslationObject, hintIcon: PIXI.Texture,) {
        this.hintIndicator = new UIGameBeginnerHintIndicatorView(uiGameManager, viewToPlaceAbove)
        this.hintInformation = new UIGameBeginnerHintInformationView(uiGameManager, this.hintIndicator.view, descriptionText, hintIcon)

        this.hintIndicator.view.setClickAction(() => {
            this.hintInformation.toggleVisibility()
            this.hintIndicator.toggleAnimation(!this.hintInformation.visible)
            if(this.hintInformation.visible) bringToFront(this.hintInformation)
        })
    }

    destroy() {
        this.hintInformation?.destroy()
        this.hintIndicator?.destroy()
    }

    hideInformation() {
        this.hintInformation.visible = false
    }
}
